import IconAvatrade from "../../assets/images/home/avatrade.svg";
import IconCBOE from "../../assets/images/home/CBOE.svg";
import IconDefiance from "../../assets/images/home/Defiance.svg";
import IconEtoro from "../../assets/images/home/Etoro.svg";
import IconFundment from "../../assets/images/home/fundment.svg";
import IconGlobalx from "../../assets/images/home/globalx.svg";
import IconIG from "../../assets/images/home/IG.svg";
import IconLeverageShares from "../../assets/images/home/leverageshares.svg";
import IconMelanion from "../../assets/images/home/melanion.svg";
import IconPlus500 from "../../assets/images/home/plus500.svg";
import IconRexShares from "../../assets/images/home/rexshares.svg";
import IconSix from "../../assets/images/home/six.svg";
import IconStoneX from "../../assets/images/home/stonex.svg";
import IconThemes from "../../assets/images/home/ThemesETFs.svg";
import IconTidal from "../../assets/images/home/Tidal.svg";
import IconVistashares from "../../assets/images/home/VistaShares.svg";
import IconXm from "../../assets/images/home/xm.svg";

export const CLIENT_LIST = [
  {
    id: 0,
    label: "Six",
    image: IconSix,
  },
  {
    id: 1,
    label: "Cboe",
    image: IconCBOE,
  },
  {
    id: 2,
    label: "Plus500",
    image: IconPlus500,
  },
  {
    id: 3,
    label: "AVATRADE",
    image: IconAvatrade,
  },
  {
    id: 4,
    label: "IG", //need to find this
    image: IconIG,
  },
  {
    id: 5,
    label: "StoneX",
    image: IconStoneX,
  },
  {
    id: 6,
    label: "XM",
    image: IconXm,
  },
  {
    id: 7,
    label: "Global X",
    image: IconGlobalx,
  },
  {
    id: 8,
    label: "Themes ETFs",  //need to find this too
    image: IconThemes,
  },
  {
    id: 9,
    label: "Rex Shares",
    image: IconRexShares,
  },
  {
    id: 10,
    label: "Defiance", //find this
    image: IconDefiance,
  },
  {
    id: 11,
    label: "MelanionCapital",
    image: IconMelanion,
  },
  {
    id: 12,
    label: "Leverage Shares",
    image: IconLeverageShares,
  },
  {
    id: 13,
    label: "Vistashares",
    image: IconVistashares, //find this too
  },
  {
    id: 14,
    label: "Fundment",
    image: IconFundment,
  },  
  {
    id: 15,
    label: "eToro",
    image: IconEtoro, //find this logo too
  },
  {
    id: 16,
    label: "Tidal",
    image: IconTidal, //find this logo
  },
];

export const CLIENT_LIST_DESKTOP = [
  [
    [
      {
        id: 0,
        label: "Six",
        image: IconSix,
      },
      {
        id: 1,
        label: "Cboe",
        image: IconCBOE,
      },
      {
        id: 2,
        label: "Plus500",
        image: IconPlus500,
      },
      {
        id: 3,
        label: "AVATRADE",
        image: IconAvatrade,
      },
    ],
    [
      {
        id: 4,
        label: "IG",
        image: IconIG,
      },
      {
        id: 5,
        label: "StoneX",
        image: IconStoneX,
      },
      {
        id: 6,
        label: "XM",
        image: IconXm,
      },
      {
        id: 7,
        label: "Global X",
        image: IconGlobalx,
      },
    ],
  ],
  [
    [
      {
        id: 8,
        label: "Themes ETFs",
        image: IconThemes,
      },
      {
        id: 9,
        label: "Rex Shares",
        image: IconRexShares,
      },
      {
        id: 10,
        label: "Defiance",
        image: IconDefiance,
      },
    ],
    [
            {
        id: 11,
        label: "Melanion Capital",
        image: IconMelanion,
      },
      {
        id: 12,
        label: "Leverage Shares",
        image: IconLeverageShares,
      },
      {
        id: 13,
        label: "Vistashares",
        image: IconVistashares,
      },
    ]
  ],
  [
    [ 
      {
        id: 14,
        label: "Fundment",
        image: IconFundment,
      },
      {
        id: 15,
        label: "eToro",
        image: IconEtoro,
      },
      {
        id: 16,
        label: "Tidal",
        image: IconTidal,
      },      
    ]
  ]
];

export const CAROUSEL_BREAKPOINTS = {
  0: {
    slidesPerView: 2,
    slidesPerGroup: 1,
  },
  480: {
    slidesPerView: 2,
    slidesPerGroup: 1,
  },
  600: {
    slidesPerView: 2,
    slidesPerGroup: 1,
  },
}


